module.exports = __webpack_public_path__ + "static/media/exam_creation.eada2529.png";